import dayjs from 'dayjs';

/** Check if capability is currently active */
export const isCapabilityActive = (cap) => !cap.end_date || dayjs().isBefore(cap.end_date, 'date');
